// src/App.tsx
import React, { useEffect, useState } from 'react';
import { BuilderComponent, builder, useIsPreviewing } from '@builder.io/react';
import componentsBuild from 'src/copmonents';
import { GeneralService, HttpService } from 'src/api';

builder.init('111320ab7fe742e9bccf22f1bb8e9a94');

componentsBuild();

const BuilderPage = () => {
  const isPreviewingInBuilder = useIsPreviewing();
  const [notFound, setNotFound] = useState(false);
  const [content, setContent] = useState(undefined);
  const http = new HttpService(
    () => ({
      baseURL: 'https://rvskm04khb.execute-api.eu-west-1.amazonaws.com/dev'
    }),
    {}
  );
  const generalService = new GeneralService(http);

  // get the page content from Builder
  useEffect(() => {
    async function fetchContent() {
      const content = await builder
        .get('page', {
          url: window.location.pathname
        })
        .promise();

      setContent(content);
      setNotFound(!content);

      // if the page title is found,
      // set the document title
      if (content?.data.title) {
        document.title = content.data.title;
      }
    }
    fetchContent();
  }, [window.location.pathname]);

  // If no page is found, return
  // a 404 page from your code.
  // The following hypothetical
  // <FourOhFour> is placeholder.
  if (notFound && !isPreviewingInBuilder) {
    return <h1>404 PAGE NOT FOUND</h1>;
  }

  return (
    <div>
      {content !== undefined && (
        <BuilderComponent
          model='page'
          content={content}
          context={{
            callBuilderApi: (
              url: string,
              method: 'POST' | 'GET' | 'PUT',
              data?: any
            ) => generalService.builderApi(url, method, data)
          }}
        />
      )}
    </div>
  );
};

export { BuilderPage };
